import { appealsApi } from '../appealsApi';

// Agent Types
export interface AgentChatRequest {
  message: string;
  conversationId?: string;
  remitId?: string;
  claimIndex?: number;
  denialCode?: string;
  temperature?: number;
  maxTokens?: number;
}

export interface AgentChatResponse {
  conversationId: string;
  message: string;
  toolsUsed: ToolUsageInfo[];
  tokenUsage?: TokenUsageInfo;
}

export interface ToolUsageInfo {
  name: string;
  success: boolean;
  durationMs: number;
}

export interface TokenUsageInfo {
  promptTokens: number;
  completionTokens: number;
  totalTokens: number;
}

export interface AgentInfoResponse {
  agentId: string;
  name: string;
  description: string;
  tools: ToolInfo[];
}

export interface ToolInfo {
  name: string;
  description: string;
}

const agentEndpoints = appealsApi.injectEndpoints({
  endpoints: (builder) => ({
    // Send a message to the AI Agent
    // POST /api/v1/agent/chat
    chatWithAgent: builder.mutation<AgentChatResponse, AgentChatRequest>({
      query: (body) => ({
        url: 'api/v1/agent/chat',
        method: 'POST',
        body,
      }),
    }),

    // Get agent information and capabilities
    // GET /api/v1/agent/info
    getAgentInfo: builder.query<AgentInfoResponse, void>({
      query: () => 'api/v1/agent/info',
    }),
  }),
  overrideExisting: false,
});

export const { useChatWithAgentMutation, useGetAgentInfoQuery } = agentEndpoints;
